let Accordion = function () {
    let options = {};

    let initialize = function (el) {
        options.$el = $(el);

        $(options.$el.data('trigger'), options.$el).on('click keydown', function (e) {
            if (e.key === 'Enter' || e.keyCode === 13 || e.type === 'click') {
                e.preventDefault();
                e.stopImmediatePropagation();

                let $el = $(this).parent(),
                    $target = $(options.$el.data('target'), $el);

                if ($target.is(':visible')) {
                    hideTarget($target, $el);
                } else {
                    showTarget($target, $el);
                }
            }
        });
    }
    , showTarget = function ($target, $el) {
        let $panelWrappers = options.$el.find(options.$el.data('trigger')).parent().filter('.open');
        hideTarget($panelWrappers.find(options.$el.data('target')), $panelWrappers)

        $el.addClass('open');
        $el.attr('aria-expanded', 'true');
        $target.addClass('active').stop(true, true).slideDown();

        if ($target.hasClass('tx-solr-searchbox')) {
            var $input = document.getElementById('inputText');
            $input.focus();
            $input.select();
        }

        setTimeout(() => {
          let sliders = $target.find('.slideshow .bxslider');
          let sliderIds = [];
          sliders.each(function() {
            sliderIds.push(this.id);
          });
          const reloadSliderEvent = new CustomEvent('reloadSlider', {
            detail: {
              sliderIds: sliderIds
            }
          });
          document.dispatchEvent(reloadSliderEvent);
        }, 100);
    }
    , hideTarget = function ($target, $el) {
        $target.stop(true, true).slideUp(200, function () {
            $target.removeClass('active');
            $el.attr('aria-expanded', 'false');
            $el.removeClass('open');
        });
    };

    // Expose the public API.
    return {
        init: initialize,
        show: showTarget,
        hide: hideTarget
    };
};

export default function (el) {
    let accordion = new Accordion();
    accordion.init(el);

    return accordion;
};
